import store from '@/store/index.js';

export default function getCompanyId(route) {
	let companyid = 0;
	let routeTokens;
	let userInfo;

	if (store.getters['app/VUE_APP_NAME'] === 'accessweb') {
		//if this is a component running in AccessWeb
		//get the token from the cid query param
		let params = new URLSearchParams(window.location.search);
		let cid = 0;

		if (params.has('cid')) {
			cid = parseInt(params.get('cid'));
		}

		if (cid > 0) {
			companyid = parseInt(params.get('cid'));
		} else {
			userInfo = store.getters['user/userInfo'];

			if (userInfo) {
				companyid = userInfo.CurrentEmployeeCompanyId;
			}
		}
	} else if (route && route.params) {
		companyid = route.params.companyid;
	} else {
		routeTokens = window.location.pathname.split('/');

		if (routeTokens) {
			for (let index = 0; index < routeTokens.length; index++) {
				if (routeTokens[index] === 'company') {
					companyid = routeTokens[index + 1];
					break;
				}
			}
		}
	}

	return parseInt(companyid);
}
